<template>
  <div>
    <table>
      <tr>
        <th>Contractnummer</th>
        <td>{{ contract.id }}</td>
      </tr>
      <tr>
        <th>Begindatum</th>
        <td>{{ contract.start_date }}</td>
      </tr>
      <tr v-if="contract.end_date != null">
        <th>Einddatum</th>
        <td>{{ contract.end_date }}</td>
      </tr>
      <tr>
        <th>Adres</th>
        <td>
          {{ contract.street }} {{ contract.house_number
          }}{{
            contract.house_number_addition != ""
              ? ` ${contract.house_number_addition}`
              : ""
          }},
          {{ contract.zip_code }}
          {{ contract.city }}
        </td>
      </tr>
      <tr
        v-if="!this.hideRecurringAmount && contract.recurring_payment != null"
      >
        <th>Termijnbedrag</th>
        <td>
          <money-format
            :value="contract.recurring_payment.total_incl_vat"
            locale="nl"
            currency-code="EUR"
            :subunit-value="true"
            :hide-subunits="false"
          >
          </money-format>
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import MoneyFormat from "vue-money-format";

export default {
  props: ["contract", "hideRecurringAmount"],
  components: { MoneyFormat }
};
</script>

<style></style>
